"use client";
import { ConfigTypes } from "@/api/AppApi/common-interfaces/api-enums";
import {
  CategoryStyleTypes,
  ICategory,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import ProductsWithFilters from "../common/produts-with-filters/ProductsWithFilters";
import Categories from "../../common-builder/Category/Categories";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useIsMobile } from "@/hooks/useIsMobile";

interface Props {
  subcategories: ICategory[];
  isSubCategory?: boolean;
  categoryId?: string | number;
  searchParams: { [key: string]: string };
  PixeListName: string;
  /** First page of products fetched on the server (see ProductsWithFilters.initialProducts). */
  initialProducts?: any[];
}

const CategoryDetailsBlackBox: React.FC<Props> = ({
  subcategories,
  isSubCategory,
  categoryId,
  searchParams,
  PixeListName,
  initialProducts,
}) => {
  const t = useTranslation();
  const isMobile = useIsMobile();
  const getCompany = useGetCompanyQuery();
  const { show_category_image, show_subcategory_image } =
    getCompany?.data?.result?.theme?.components?.product ?? {};
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? 16 : 24,
      }}
    >
      {subcategories?.length > 0 && (
        <Categories
          isSubCategory={isSubCategory}
          data={subcategories}
          configurations={{
            style_type: CategoryStyleTypes.circle_icon,
            type: ConfigTypes.carousel,
          }}
          show_category_image={show_category_image!}
          show_subcategory_image={show_subcategory_image!}
          text={{
            view_all: t.view_all,
          }}
        />
      )}
      <ProductsWithFilters
        searchParams={searchParams}
        categoryId={categoryId}
        isCategoryPage
        PixeListName={PixeListName}
        PixeListId={categoryId?.toString() || ""}
        initialProducts={initialProducts}
      />
    </div>
  );
};
export default CategoryDetailsBlackBox;
